/* Palsora story sections: keep size-specific content (3.2L / 7L) in step with the chosen variant, and send "choose" buttons back to the buy box */
(function () {
  if (window.__palsStory) return;
  window.__palsStory = true;
  var root = document.documentElement;

  function bigIds() {
    var el = document.querySelector('script[data-pals-big]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function currentId() {
    var inp = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (inp && inp.value) return String(inp.value);
    var m = location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }
  function sync() {
    var ids = bigIds();
    if (!ids) return;
    var id = currentId();
    if (!id) return;
    var size = ids.indexOf(Number(id)) > -1 || ids.indexOf(String(id)) > -1 ? '7l' : '32';
    if (root.getAttribute('data-pals-size') !== size) root.setAttribute('data-pals-size', size);
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(sync, 60); }
  document.addEventListener('change', soon, true);
  document.addEventListener('click', soon, true);
  window.addEventListener('popstate', soon);
  document.addEventListener('DOMContentLoaded', sync);
  setInterval(sync, 800);
  sync();

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pals-to-buy]');
    if (!b) return;
    e.preventDefault();
    var box = document.querySelector('.product__info-wrapper, .product__info-container, product-info') || document.querySelector('form[action*="/cart/add"]');
    if (box) box.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    /* "Subscribe" buttons also tick the subscription option in the buy box */
    if (/subscri/i.test(b.textContent)) {
      var on = document.querySelector('[data-pals-sub-on]');
      if (on && !on.checked) on.click();
    }
  });
})();
